module.exports = __webpack_public_path__ + "img/derHut.d0eb3304.jpg";